/**
 * <RevisionProgramsSection> — the "Mes programmes de révision" block of the parent home
 * (template, L0.1).
 *
 * Mirrors the legacy study-programs block in `ParentSubscribeScreen`: a titled list of
 * `<RevisionProgramCard>`s. Legacy hides the whole block when there is no program, so this
 * template renders nothing when `revisionPrograms` is empty. Thin domain wrapper over `<List>`.
 */
import React from "react"

import { List } from "../../molecules/List"
import { RevisionProgramCard } from "../../organisms/RevisionProgramCard"
import { type UIRevisionProgram } from "../../../ports/primary/ui/types"

export type RevisionProgramsSectionProps = {
    revisionPrograms: UIRevisionProgram[]
    onOpenRevisionProgram?: (program: UIRevisionProgram) => void
}

export function RevisionProgramsSection(props: RevisionProgramsSectionProps) {
    const { revisionPrograms, onOpenRevisionProgram } = props
    if (revisionPrograms.length === 0) return null

    return (
        <List title="Mes programmes de révision">
            {revisionPrograms.map((program) => (
                <RevisionProgramCard
                    key={program.id}
                    program={program}
                    onPress={() => onOpenRevisionProgram?.(program)}
                />
            ))}
        </List>
    )
}
